import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Button, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const ButtonsDiv = styled.div`
    display: flex;
    margin-top: 10px;
`;

const DetailsDiv = styled.div`
    display: flex;
    flex-direction: column;
`;

const CopyButton = styled(Button)`
    margin-left: 12px;
`;

const StyledAccordion = styled(Accordion)`
    margin-top: 24px;
`;

const StyledDownloadButton = styled(Button)`
    margin-left: 12px;
`;

interface RSAPublicKeyProps {
    rsaPublicKey: string;
}

const RSAPublicKey: React.FC<RSAPublicKeyProps> = ({ rsaPublicKey }) => {
    const { t } = useTranslation('admin_settings');

    const CopyRSAButton = () => {
        const copyXML = () => {
            navigator.clipboard.writeText(rsaPublicKey);
        };
        return (
            <CopyButton
                onClick={copyXML}
                variant='outlined'
            >
                {t('copy')}
            </CopyButton>
        );
    };

    const DownloadButton: React.FC = () => {
        const downloadXML = () => {
            const element = document.createElement('a');
            const file = new Blob([rsaPublicKey], {
                type: 'text/xml'
            });
            element.href = URL.createObjectURL(file);
            element.download = 'id_rsa.pub';
            document.body.appendChild(element);
            element.click();
        };
        return <StyledDownloadButton onClick={downloadXML} variant='outlined'>{t('download')}</StyledDownloadButton>;
    };
    return (
        <StyledAccordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon/>}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography>{t('rsa-public-key')}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <DetailsDiv>
                    <TextField
                        multiline
                        rows={28}
                        value={rsaPublicKey}
                        disabled
                    />
                    <ButtonsDiv>
                        <CopyRSAButton/>
                        <DownloadButton/>
                    </ButtonsDiv>
                </DetailsDiv>
            </AccordionDetails>
        </StyledAccordion>
    );
};

export default RSAPublicKey;
